export default __webpack_public_path__ + "8e84133.png";